namespace $.$$ {
	export class $shm_textarea_code extends $.$shm_textarea_code {
		style(): { [key: string]: string | number } {
			return { ...super.style(), '--shm-textarea-code-gutter': this.gutter() }
		}

		gutter() {
			const digits = String( this.value().split( /\r\n?|\n/ ).length ).length
			return `calc(1.75rem + ${Math.max( 0, digits - 3 )}ch)`
		}
	}
}
